export default "__VITE_ASSET__50dce0fe__"